import { Component, computed, effect, inject, input, output, ViewChild } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MyCustomPaginatorIntl } from './my-custom-paginator-intl';

@Component({
  selector: 'table-datatable-paginator',
  templateUrl: './datatable-paginator.component.html',
  styleUrls: ['./datatable-paginator.component.scss'],
  imports: [MatFormFieldModule, MatSelectModule, MatPaginatorModule, MatInputModule],
  providers: [{ provide: MatPaginatorIntl, useValue: new MyCustomPaginatorIntl() }],
})
export class DatatablePaginatorComponent {
  tableWidth = input<number>();
  pageIndex = input(0);
  pageSize = input<number>();
  dataCount = input<number>();
  maxPageIndex = input<number>();
  showDataCountAsPageSizeOption = input<boolean>();
  pageSizeOptions = input<number[]>();
  hidePageSize = input<boolean>();

  pageIndexChange = output<Event>();
  pageChange = output<PageEvent>();

  paginatorIntl = inject(MatPaginatorIntl);

  isSmall = computed(() => (this.tableWidth() || 0) < 750);
  isVerySmall = computed(() => (this.tableWidth() || 0) < 600);

  emptyLabelWhenSmall = effect(() => {
    this.paginatorIntl.itemsPerPageLabel = this.isSmall() ? '' : 'Items per page:';
    this.paginatorIntl.changes.next();
  });

  @ViewChild(MatPaginator) paginator: MatPaginator;

  itemsPerPage = computed(() => {
    const options = this.pageSizeOptions() ?? [15, 25, 50, 100, 500, 1000];
    const dataCount = this.dataCount();
    if (this.showDataCountAsPageSizeOption() && dataCount > Math.max(...options)) {
      options.push(dataCount);
    }
    options.sort((a, b) => a - b);
    return options;
  });
  MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER;

  getValueFromPageIndexInput(event: Event) {
    const target = event.target as HTMLInputElement;
    const int = parseInt(target.value);
    if (int < 1) {
      target.value = 1 as any;
    } else if (int - 1 > this.maxPageIndex() - 1) {
      target.value = this.maxPageIndex() as any;
    } else {
      target.value = int as any;
    }
  }

  onPageSelectionChange($event: MatSelectChange) {
    const pageEvent: PageEvent = {
      previousPageIndex: this.pageIndex(),
      pageIndex: this.pageIndex(),
      pageSize: $event.value,
      length: this.dataCount(),
    };
    this.pageChange.emit(pageEvent);
    this.paginator?._changePageSize($event.value);
  }
}
